















































































































































































import Vue from "vue";
import { mapActions, mapState } from "vuex";
import graphqlQuery from "@/service/Api";
import axios from "axios";
import { getInitialsName } from "@/helpers";
const basePhotoUrl = process.env.VUE_APP_BASE_PHOTO_URL;

interface HTMLInputEvent extends Event {
  target: HTMLInputElement & EventTarget;
}

export default Vue.extend({
  components: {
    ModalPrimary: () => import("@/components/modal/ModalPrimary.vue"),
    InputProfile: () => import("@/components/profile/InputProfile.vue"),
  },
  data() {
    return {
      status: "Aktif",
      inputFilePhoto: "",
      isLoading: false,
      isModalPhoto: false,
      isModalResetPhoto: false,
      isPhotoError: false,
      isChangePhotoDropdown: false,
      changeDropdownStyle: {
        left: 0,
        top: 0,
      },
      basePhotoUrl: basePhotoUrl,
      userProfileForm: {
        fullname: "" as string,
        unit: { name: "" },
        role: { name: "" },
      },
    };
  },
  computed: {
    ...mapState("authService", ["userProfile", "token"]),
    isValidEditProfile(): boolean {
      return (
        this.userProfile.fullname !== this.userProfileForm.fullname &&
        this.userProfileForm.fullname !== null
      );
    },
  },
  methods: {
    graphqlQuery,
    getInitialsName,
    ...mapActions("authService", ["getUserProfile"]),
    // NOTE [method] Ubah Foto Profil
    async changePhoto(e: HTMLInputEvent) {
      if (e.target?.files) {
        /**
         * LINK : Referensi
         * https://stackoverflow.com/questions/59043021/how-do-i-upload-files-to-a-graphql-backend-implemented-using-graphql-upload-usin
         */

        console.log("changePhoto");
        const formData = new FormData();
        // let file: File = e.target.files[0];
        // formData.append("0", file);
        const query = `
          mutation($picture: Upload!) {
            changeProfilePhoto(picture: $picture)
          }
        `;
        const operations = JSON.stringify({
          query,
          variables: { picture: null },
        });
        formData.append("operations", operations);

        const map = {
          "0": ["variables.picture"],
        };
        formData.append("map", JSON.stringify(map));

        let file: File = e.target.files[0];
        formData.append("0", file);
        this.isLoading = true;
        const data = await axios({
          url: process.env.VUE_APP_BASE_GRAPHQL,
          method: "post",
          data: formData,
          headers: {
            Authorization: this.token ? "Bearer " + this.token : undefined,
          },
        })
          .then(async (res) => {
            await this.getUserProfile();
            this.isPhotoError = false;
            console.log("Berhasil", res.data);
          })
          .catch((err) => {
            console.log("error", err);
          });
        this.isLoading = false;
        console.log("file", file);
        return data;
      }
    },
    async resetProfilePhoto() {
      const query = `
        mutation {
          resetProfilePhoto
        }
      `;
      await this.graphqlQuery({ query });
      await this.getUserProfile();
      this.isModalResetPhoto = false;
    },
    toggleChangePhotoDropdown(e: any) {
      console.log(e);
      this.changeDropdownStyle.left = e.clientX + 10;
      this.changeDropdownStyle.top = e.clientY + 10;
      // this.isChangePhotoDropdown = !this.isChangePhotoDropdown;
      this.isChangePhotoDropdown = true;
    },
    async updateMyProfile() {
      const query = `
        mutation {
          updateMyProfile(fullname: "${this.userProfileForm.fullname}") {
            fullname
          }
        }
      `;

      await this.graphqlQuery({ query }).then((res) => {
        this.getUserProfile();
        return res;
      });
    },
  },
  mounted() {
    this.userProfileForm = { ...this.userProfile };
  },
});
